










































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import CancelRejectPaymentOrderRequest from '@/models/Accounts/Shared/PaymentOrders/CancelRejectPaymentOrderRequest';

@Component({ name: 'PaymentOrderReject' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    isCustomerAccount: boolean;

    request: CancelRejectPaymentOrderRequest = new CancelRejectPaymentOrderRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CancelRejectPaymentOrderRequest();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            if (this.isCustomerAccount) {
                await DepositAccountModule.rejectPaymentOrder(this.request);
            }
            else {
                await InstitutionAccountModule.rejectPaymentOrder(this.request);
            }
        }
    }

}
